<rap-profile-nav-bar></rap-profile-nav-bar>
<!-- <nav class="navbar navbar-expand-lg navbar-light bg-black body-header" [ngClass]="getBodyClass()">
    <div class="container-fluid">
    </div>
</nav> -->
<div class="body" [ngClass]="getBodyClass()">
    <router-outlet></router-outlet>
</div>